import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate, useSearchParams } from 'react-router-dom';

const ReviewWrite = () => {
  const [searchParams] = useSearchParams();
  const productId = searchParams.get('product_id');
  const navigate = useNavigate();

  const [product, setProduct] = useState(null);
  const [rating, setRating] = useState('');
  const [content, setContent] = useState('');
  const [image, setImage] = useState(null);
  const [previewUrl, setPreviewUrl] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // URL에 파라미터가 들어왔는지 먼저 확인
    console.log("리뷰 작성 페이지 진입 - 상품 ID:", productId);

    if (!productId) {
      alert("상품 정보가 없습니다.");
      navigate(-1);
      return;
    }

    const fetchProduct = async () => {
      try {
        setLoading(true);
        // Flask API: @review_bp.route('/review/product_info/<int:product_id>')
        const res = await axios.get(`/api/review/product_info/${productId}`, { 
          withCredentials: true 
        });
        
        console.log("상품 정보 로드 결과:", res.data);
        setProduct(res.data.product);
      } catch (err) {
        console.error("상품 정보 로드 에러:", err);
        // 401 에러(로그인 만료) 처리
        if (err.response?.status === 401) {
          alert("로그인이 필요합니다.");
          navigate('/login');
        }
      } finally {
        setLoading(false);
      }
    };

    fetchProduct();
  }, [productId, navigate]);

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setImage(file);
      setPreviewUrl(URL.createObjectURL(file));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!rating) return alert("별점을 선택해주세요.");

    const formData = new FormData();
    formData.append('product_id', productId);
    formData.append('rating', rating);
    formData.append('content', content);
    if (image) formData.append('image', image);

    try {
      // ✅ Flask API 주소 수정: /review/submit
      const res = await axios.post('/api/review/submit', formData, {
        withCredentials: true,
        headers: { 'Content-Type': 'multipart/form-data' }
      });
      
      if (res.data.success) {
        alert("리뷰가 등록되었습니다.");
        navigate('/reviews'); 
      }
    } catch (err) {
      const msg = err.response?.data?.message || "등록 중 오류가 발생했습니다.";
      alert(msg);
    }
  };

  // 1. 로딩 중 화면
  if (loading) return <div style={styles.centerText}>상품 정보를 불러오는 중...</div>;

  // 2. 데이터가 없을 때 가드 (에러 방지용 필수 코드)
  if (!product) return <div style={styles.centerText}>상품 정보를 찾을 수 없습니다.</div>;

  return (
    <div className="container" style={styles.container}>
      <h2 style={styles.title}>리뷰 작성</h2>

      <div style={styles.productCard}>
        <img 
          src={product.image_path?.startsWith('http') ? product.image_path : `/static/${product.image_path}`} 
          alt="상품" 
          style={styles.productImg}
        />
        <div style={styles.productName}>{product.name}</div>
      </div>

      <form onSubmit={handleSubmit}>
        <div style={styles.formGroup}>
          <label style={styles.label}>별점</label>
          <select className="form-select" value={rating} onChange={(e) => setRating(e.target.value)} required>
            <option value="">선택하세요</option>
            <option value="5">★★★★★ (5점)</option>
            <option value="4">★★★★☆ (4점)</option>
            <option value="3">★★★☆☆ (3점)</option>
            <option value="2">★★☆☆☆ (2점)</option>
            <option value="1">★☆☆☆☆ (1점)</option>
          </select>
        </div>

        <div style={styles.formGroup}>
          <label style={styles.label}>상세 후기</label>
          <textarea className="form-control" rows="5" value={content} onChange={(e) => setContent(e.target.value)} required placeholder="구매하신 상품은 어떠셨나요?"></textarea>
        </div>

        <div style={styles.formGroup}>
          <label style={styles.label}>사진 첨부</label>
          <input type="file" className="form-control" accept="image/*" onChange={handleFileChange} />
          {previewUrl && <img src={previewUrl} alt="미리보기" style={styles.previewImg} />}
        </div>

        <div style={styles.btnGroup}>
          <button type="submit" className="btn btn-primary" style={styles.submitBtn}>등록하기</button>
          <button type="button" className="btn btn-secondary" onClick={() => navigate(-1)} style={styles.cancelBtn}>취소</button>
        </div>
      </form>
    </div>
  );
};

const styles = {
  container: { maxWidth: '600px', margin: '40px auto', padding: '0 15px' },
  centerText: { textAlign: 'center', marginTop: '100px', fontSize: '18px' },
  title: { fontSize: '24px', fontWeight: 'bold', marginBottom: '25px' },
  productCard: { display: 'flex', alignItems: 'center', padding: '15px', background: '#f8f9fa', borderRadius: '10px', marginBottom: '30px' },
  productImg: { width: '80px', height: '80px', objectFit: 'cover', borderRadius: '5px', marginRight: '15px' },
  productName: { fontSize: '18px', fontWeight: 'bold' },
  formGroup: { marginBottom: '20px' },
  label: { display: 'block', marginBottom: '8px', fontWeight: '600' },
  previewImg: { width: '100%', height: 'auto', marginTop: '10px', borderRadius: '5px' },
  btnGroup: { display: 'flex', gap: '10px', marginTop: '30px' },
  submitBtn: { flex: 2, padding: '12px', fontWeight: 'bold' },
  cancelBtn: { flex: 1, padding: '12px' }
};

export default ReviewWrite;